module.exports = __webpack_public_path__ + "c010a0025faca613cf6e99a8616418aa.png";